














import Vue from "vue";
import iwInputText from "@/encoding/components/buildingBlocks/InputText.vue";
import { v4 as uuidv4 } from "uuid";

export default Vue.extend({
    components: {
        iwInputText: iwInputText,
    },
    props: {
        errorMessage: {
            type: String,
            required: false,
            default: null
        },
    },
    data: function() {
        return {
            pathInStore: "customer.location.address.provided.locality", // TO CHANGE WITH CORRECT PATH
            specificId: uuidv4() as string
        };
    },
    computed: {
        locality: function(): string|null {
            return this.$store.getters["FormModule/getValueUI"](this.pathInStore);
        },
    },
    methods: {
        updateText: function (event: Event) {
            const target = event.target as HTMLInputElement;
            const value = target.value;

            this.$store.commit("FormModule/addValueUI", {path: this.pathInStore, value: value});
        }
    }

});
